// TriggerResolver.ts
export class TriggerResolver {
    static resolve(action) {
        const when = (action === null || action === void 0 ? void 0 : action.when) || (action === null || action === void 0 ? void 0 : action.When);
        const typeName = (when === null || when === void 0 ? void 0 : when.TriggerType) || (when === null || when === void 0 ? void 0 : when.TypeName) || "time";
        return typeName.toLowerCase();
    }
}
